import {FC} from "react";
import {Card} from "react-bootstrap";
import useListSize from "@oldDashboard/legacyHooks/useListSize";
import Loader from "@/components/common/loader/loader";
import { numberFormat } from "@oldDashboard/legacyUtils";

interface ListSizeProps { totalStudents: String, affiliateSelected: String, launchSelected: String, timePeriodSelected: String, searching: boolean }
const ListSizeTile: FC<ListSizeProps> = ({totalStudents, affiliateSelected, launchSelected, timePeriodSelected, searching}) => {

    const { isLoading } = useListSize({affiliateSelected, launchSelected, timePeriodSelected, searching});
    
    return (
        <Card className="custom-card overflow-hidden pb-4" style={{height: '250px'}}>
            { isLoading && <Loader/> }
            <Card.Body>
                <div className="row gap-3 gap-sm-0">
                    <div className="col-12">
                        <div className="text-center d-flex flex-column justify-content-center align-items-center">
                            <h4 className="fw-semibold mb-2">List Size</h4>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="fs-12 text-muted w-100">Total Students</p>
                            </div>
                            <p className="fs-36">
                                {numberFormat(Number(totalStudents))}
                            </p>
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default ListSizeTile;
